import { render, staticRenderFns } from "./sale-invoice.vue?vue&type=template&id=7886477a&"
import script from "./sale-invoice.vue?vue&type=script&lang=js&"
export * from "./sale-invoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports